import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { setActivityTypeNull } from "../../redux/filtersSlice";
import { resetBacklink } from "../../redux/backlinkSlice";

const BaseBar = () => {
    const { link } = useSelector(state => state.backlink)
    const { filtersObject } = useSelector(state => state.filters);
    const { isLogged } = useSelector(state => state.user);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [isHome, setIsHome] = useState(false);
    const [isProfile, setIsProfile] = useState(false);
    const [isSign, setIsSign] = useState(false);
    const [isFavourites, setIsFavourites] = useState(false);

    useEffect(() => {
        if (location.pathname === "/") {
            setIsHome(true)
        } else {
            setIsHome(false)
        }
        if (location.pathname === "/my-profile") {
            setIsProfile(true)
        } else {
            setIsProfile(false)
        }
        if (location.pathname === "/register-login") {
            setIsSign(true)
        } else {
            setIsSign(false)
        }
        if (location.pathname === "/favourites") {
            setIsFavourites(true)
        }
        else {
            setIsFavourites(false)
        }
    }, [location.pathname])

    const handleBackClick = () => {
        navigate(-1);

        // Se l'utente torna da una pagina dettaglio, resetto il backlink
        // e al ritorno indietro non scrolla in alto
        if (link === "/activity-details") return;
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 10)
    }
    return (
        <div className="fixed left-0 right-0 bottom-0 z-10 w-full flex justify-center md:hidden bg-slate-100 py-4">
            <div className="w-full flex justify-evenly">
                {/* back */}
                {
                    !isHome && !isSign &&
                    <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 gap-2 cursor-pointer" onClick={handleBackClick}>
                        <div className="pt-1"><i className="fi fi-rr-angle-left text-2xl text-[#225424]"></i></div>
                    </div>
                }
                {
                    (isHome || isSign) &&
                    <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 gap-2 cursor-pointer">
                        <div className="pt-1"><i className="fi fi-rr-angle-left text-2xl text-slate-300"></i></div>
                    </div>
                }

                {/* home */}
                {
                    !isHome &&
                    <Link to="/">
                        <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 gap-2">
                            <div className="pt-1"><i className="fi fi-rr-house-chimney text-2xl text-[#225424]"></i></div>
                        </div>
                    </Link>
                }
                {
                    isHome &&
                    <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 gap-2">
                        <div className="pt-1"><i className="fi fi-rr-house-chimney text-2xl text-slate-300"></i></div>
                    </div>
                }

                {/* favourites */}
                {
                    (isLogged && !isFavourites) &&
                    <Link to="/favourites">
                        <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 gap-2">
                            <div className="pt-1"><i className="fi fi-rr-heart text-2xl text-[#225424]"></i></div>
                        </div>
                    </Link>
                }
                {
                    (!isLogged || isFavourites) &&
                    <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 gap-2">
                        <div className="pt-1"><i className="fi fi-rr-heart text-2xl text-slate-300"></i></div>
                    </div>
                }


                {/* profile */}
                {
                    (isLogged && !isProfile) &&
                    <Link to="/my-profile">
                        <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 gap-2 cursor-pointer">
                            <div className="pt-1"><i className="fi fi-rr-user text-2xl text-[#225424]"></i></div>
                        </div>
                    </Link>
                }
                {
                    (!isLogged || isProfile) &&
                    <div className="min-w-12 h-12 rounded-xl border flex justify-center items-center px-2 gap-2">
                        <div className="pt-1"><i className="fi fi-rr-user text-2xl text-slate-300"></i></div>
                    </div>
                }

            </div>
        </div>
    )
}

export default BaseBar